import React from 'react';
import { IconPencil } from '@tabler/icons';

import { IconStyles } from './styles';

export function EditIcon() {
  return (
    <IconStyles>
      <IconPencil />
    </IconStyles>
  );
}
